<template>
    <div class="main" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="main-need">
            <img src="../assets/image/login-bg.png" alt />
        </div>
        <div class="main-text">
            <div class="login-main">
                <div class="login">登录</div>
                <div class="ding-text">
                    <div class="text">钉钉扫码登录</div>
                </div>
                <div id="QR-code" v-loading="loading"></div>
            </div>
            <footer class="footer">
                © My Application 2019 ~ 2021 Powered by 合肥佳冠医疗科技有限公司
            </footer>
        </div>
        <iframe
            v-show="iframeState"
            id="show-iframe"
            frameborder="0"
            name="showHere"
            scrolling="auto"
            src=""
            ref="iframe"
        ></iframe>
    </div>
</template>
<script>
import uuidv1 from "uuid/v1";

export default {
    data() {
        return {
            form: {
                currentTeamId: 1, // 当前团队id
                seleList: [],
                currentAppId: "", // 当前钉钉登录的appId
            },
            loading: false,
            loginTmpCode: "",
            uuid: "",
            iframeState: true,
            fullscreenLoading: false,
            appId: 'dingoavtuirptxpikdh1w2', // 正式地址的appId
            // appId: "dingoaiy1uzbwiiz8peexn", // 测试地址的appId
        };
    },
    mounted: function () {
        this.setUpInfo();
        // this.getGroup(() => {
        //   this.createQrCode();
        // });
        this.createQrCode();
    },
    methods: {
        handleDDLogin(a, callback) {
            let e,
                c = document.createElement("iframe"),
                d =
                    "https://login.dingtalk.com/login/qrcode.htm?goto=" +
                    a.goto;
            (d += a.style ? "&style=" + encodeURIComponent(a.style) : ""),
                (d += a.href ? "&href=" + a.href : ""),
                (c.src = d),
                (c.frameBorder = "0"),
                (c.allowTransparency = "true"),
                (c.scrolling = "no"),
                (c.width = a.width ? a.width + "px" : "365px"),
                (c.height = a.height ? a.height + "px" : "400px"),
                (e = document.getElementById(a.id)),
                (e.innerHTML = ""),
                e.appendChild(c);
            callback();
        },
        createQrCode() {
            this.loading = true;
            this.uuid = uuidv1();
            let url = encodeURIComponent(
                this.baseUrl + "/api/v1/auth/login?temp_code=" + this.uuid
            );
            let goto = encodeURIComponent(
                "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=" +
                    this.appId +
                    "&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=" +
                    url
            );
            let obj = this.handleDDLogin(
                {
                    id: "QR-code", //这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
                    goto: goto, //请参考注释里的方式
                    style:
                        "border:none;background:transparent; margin-top:-20px",
                    width: "250",
                    height: "350",
                },
                () => {
                    this.loading = false;
                }
            );

            // 扫码
            let hanndleMessage = (event) => {
                let origin = event.origin;
                if (origin == "https://login.dingtalk.com") {
                    //判断是否来自ddLogin扫码事件。
                    this.loginTmpCode = event.data;
                    this.handleOpenDDUrl();
                }
            };
            if (typeof window.addEventListener != "undefined") {
                window.addEventListener("message", hanndleMessage, false);
            } else if (typeof window.attachEvent != "undefined") {
                window.attachEvent("onmessage", hanndleMessage);
            }
        },
        handleOpenDDUrl() {
            const url =
                "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=" +
                this.appId +
                "&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=" +
                encodeURIComponent(
                    this.baseUrl + "/api/v1/auth/login?temp_code=" + this.uuid
                ) +
                "&loginTmpCode=" +
                this.loginTmpCode;
            this.$refs.iframe.src = url;
            this.handleInitLoginCheck();
        },
        handleInitLoginCheck() {
            this.fullscreenLoading = true;
            if (window.timer) {
                clearInterval(window.timer);
            }

            window.timer = setInterval(() => {
                this.$http({
                    method: "post",
                    url: "/api/v1/auth/dingLoginCheck",
                    data: {
                        code: this.uuid,
                    },
                })
                    .then((res) => {
                        // console.log(res);
                        localStorage.setItem(
                            "dingdingUserId",
                            res.data.result.ding_user_id
                        ); //钉钉的用户id
                        localStorage.setItem(
                            "expires_in",
                            res.data.result.expires_in
                        );
                        localStorage.setItem("user_id", res.data.result.id);
                        localStorage.setItem("name", res.data.result.name);
                        localStorage.setItem(
                            "token",
                            "Bearer " + res.data.result.token
                        );
                        localStorage.setItem(
                            "is_chose_team",
                            res.data.result.is_chose_team
                        );
                        localStorage.setItem(
                            "is_tower_auth",
                            res.data.result.is_tower_auth
                        );
                        localStorage.setItem(
                            "is_admin",
                            res.data.result.is_admin
                        );
                        localStorage.setItem(
                            "union_id",
                            res.data.result.union_id
                        );
                        localStorage.setItem("uuid", this.uuid);
                        this.$router.push({ path: "/" });
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "登录提示",
                            message: error.response.data.msg,
                        });
                    })
                    .finally(() => {
                        clearInterval(window.timer);
                        this.fullscreenLoading = false;
                    });
            }, 2000);
            setTimeout(() => {
                clearInterval(window.timer);
            }, 10000);
        },
        // getGroup(callback) {
        //   this.$http({
        //     method: "post",
        //     url: "/api/v1/auth/getFirstLevelDepartment"
        //   })
        //   .then(data => {
        //     if (data.status === 200) {
        //       this.form.seleList = data.data.result;
        //       // 获取合肥华研的appid
        //       this.form.seleList.forEach((val, key) => {
        //         if (val.id == this.form.currentTeamId) {
        //           this.form.currentAppId = val.ding_appid
        //         }
        //       })
        //     }
        //   })
        //   .catch(error => {
        //     console.log(error)
        //   })
        //   .finally(() => {
        //       callback()
        //   });
        // },
        // 设置配置项 登录成功后设置
        setUpInfo() {
            let obj = [
                { name: "搜索", value: true, id: 0,status: true },
                { name: "书签", value: true, id: 1,status: true },
                { name: "消息", value: true, id: 2,status: true },
                { name: "今日事项", value: true, id: 3,status: true },
                { name: "微语录", value: true, id: 4,status: true },
                { name: "任务事项", value: true, id: 5,status: true },
                { name: "弹幕", value: true, id: 6 ,status: true},
            ];
            localStorage.setItem("setUpInfo", JSON.stringify(obj));
        },
    },
};
</script>

<style>
* {
    margin: 0;
    padding: 0;
}

html,
body,
#app,
.main,
.main-need img {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.main-need {
    height: 100%;
    width: 50%;
    float: left;
}

.main-text {
    position: relative;
    width: 580px;
    height: 100%;
}

.main-text {
    float: right;
    width: 50%;
    height: 100%;
    position: relative;
}

.main-text .login-main {
    position: absolute;
    width: 540px;
    height: 700px;
    left: 50%;
    top: 50%;
    margin-left: -270px;
    margin-top: -350px;
}

.login-main .login {
    font-size: 58px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 76px;
    color: rgba(55, 122, 255, 1);
}

.login-sele .el-select {
    width: 100%;
    margin-top: 40px;
}

.ding-text {
    position: relative;
    width: 100%;
    height: 1px;
    background-color: #e4e4e4;
    margin-top: 50px;
}

.ding-text .text {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    width: 200px;
    height: 20px;
    background-color: #fff;
    color: #b4b6c3;
}

#QR-code {
    width: 250px;
    height: 285px;
    margin: 50px auto;
    background: #f9f9f9;
}

.footer {
    font-size: 14px;
    position: absolute;
    bottom: 30px;
    width: 420px;
    left: 50%;
    margin-left: -200px;
    color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue